// extracted by mini-css-extract-plugin
export default {"asosLogo":"D5Ykbau","link":"afrMdWS TYb4J9A"};